export default __webpack_public_path__ + "static/media/bolinhas.a40d8350.svg";